import { parseNumber } from '@jbc-year-end-adj/2024/utils/income/parseNumber';

// @ts-ignore
import { numberWithSplit } from '@jbc-year-end-adj/2024/utils/income';

type TotalSalaryIncome = {
  mainJobIncome: string | undefined;
  sideJobIncome: string | undefined;
  formerJobsPaymentAmountSum: number;
};

export const calcTotalSalaryIncome = ({ mainJobIncome, sideJobIncome, formerJobsPaymentAmountSum }: TotalSalaryIncome): string => {
  const totalSalaryIncome = parseNumber(mainJobIncome) + parseNumber(sideJobIncome) + parseNumber(formerJobsPaymentAmountSum);
  return numberWithSplit(totalSalaryIncome);
};
